try {
  $(document).on('contextmenu dragstart', 'img, video, .pdp-zoom', function (e) {
    e.preventDefault();
  });
} catch (e) {
  console.error(e);
}
